export default __webpack_public_path__ + "static/char-48-1fff408c347c5ba16da70c4add0fd186.gif";